import type React from "react";

interface PlanHeroProps {
	title: React.ReactNode;
	subtitle: string;
	availabilityText?: string;
}

export default function PlanHero({
	title,
	subtitle,
	availabilityText,
}: PlanHeroProps) {
	return (
		<div className="flex w-full flex-col items-center gap-6">
			{/* Availability + Title */}
			<div className="flex w-full flex-col items-center gap-4">
				{availabilityText && (
					<p className="font-display text-sm font-medium leading-5 text-[rgba(9,10,12,0.56)]">
						{availabilityText}
					</p>
				)}
				<h1 className="font-display text-center text-[48px] font-bold leading-[48px] tracking-[-0.48px] text-[#090a0c]">
					{title}
				</h1>
			</div>

			{/* Subtitle */}
			<p className="font-display w-full text-center text-[18px] leading-7 tracking-[0.36px] text-[rgba(9,10,12,0.64)]">
				{subtitle}
			</p>
		</div>
	);
}
